var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanappSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_181",
    "data-name": "Groupe 181",
    transform: "translate(-1694 -307)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(1694 307)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Canapp-Logo",
    transform: "translate(1708 327.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M13.86,26.915a13.591,13.591,0,0,1-9.9-3.859A12.844,12.844,0,0,1,0,13.454a12.849,12.849,0,0,1,3.953-9.6A13.618,13.618,0,0,1,13.86,0a13.92,13.92,0,0,1,8.92,3,12.359,12.359,0,0,1,4.636,7.737H19.6a6.1,6.1,0,0,0-2.291-2.649,6.276,6.276,0,0,0-3.453-.98A6.06,6.06,0,0,0,9.352,8.92a6.19,6.19,0,0,0-1.791,4.534,6.19,6.19,0,0,0,1.791,4.534A6.06,6.06,0,0,0,13.86,19.8a6.276,6.276,0,0,0,3.453-.98A5.978,5.978,0,0,0,19.6,16.171h7.812a12.406,12.406,0,0,1-4.636,7.737,13.92,13.92,0,0,1-8.92,3Z",
    transform: "translate(0 -0.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M288.56,33.426a4.963,4.963,0,0,1-3.629,1.439,4.92,4.92,0,0,1-5.041-5.041,4.772,4.772,0,0,1,1.439-3.554,4.879,4.879,0,0,1,3.6-1.439,4.963,4.963,0,0,1,3.629,1.439,4.791,4.791,0,0,1,1.46,3.554,4.887,4.887,0,0,1-1.46,3.6Z",
    transform: "translate(-252.064 -8.055)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanappSupportIcon);
export default __webpack_public_path__ + "static/media/canapp-support-icon.7393c1f4b60060ab5defa0d9624f68dc.svg";
export { ForwardRef as ReactComponent };